import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles((theme) => ({
    paper: ({ maxWidth }) => ({
        maxWidth: typeof maxWidth === "number" ? maxWidth : undefined,
        [theme.breakpoints.down("sm")]: {
            "&.MuiDialog-paperScrollBody": {
                width: "calc(100% - 32px)",
            },
            "&.MuiDialog-paperScrollPaper": {
                maxHeight: "calc(100% - 32px)",
            },
            "&.MuiDialog-paperFullScreen": {
                width: "100%",
                height: "100%",
                maxWidth: "100%",
                maxHeight: "100%",
            },
            "&:not(.MuiDialog-paperFullScreen)": {
                margin: 16,
                maxWidth: "calc(100% - 32px)",
                width: "calc(100% - 32px)",
            },
        },
    }),
    paper_loading: {
        background: "transparent",
        boxShadow: "none",
    },
    paper_smallPadding: {
        "&:not(.MuiDialog-paperFullScreen)": {
            padding: theme.spacing(2, 2.5),
        },
    },
    toolbar: {
        minHeight: 64,
    },
    toolbar__cross: {
        padding: "8px !important",
    },
    title: {
        fontSize: 24,
        lineHeight: 1.25,
        [theme.breakpoints.down("sm")]: {
            fontSize: 18,
            paddingTop: 10,
        },
    },
    buttonClose: {
        position: "absolute",
        zIndex: 1,
    },
    spinner: {
        margin: "0 auto",
    },
}));
//# sourceMappingURL=ui_dialog_responsive.css.js.map